const sourceTypes = {
  NODE: 'Node',
  BUTTERFLYNODE: 'ButterflyNode',
}

export default sourceTypes
